import {
  getAppInfoByCode,
  getCompanyInfo,
  getCompanyList,
  selectCompany,
  checkEntAuth,
  getAuthLink,
  logOut,
  getUserStaffInfo,
  getUserPermissions,
} from '@/api/user-api.js'
export default {
  namespaced: true,
  state: {
    userInfo: {},
    companyList: [],
    // 员工信息
    staffInfo: {},
    // 账号权限
    permissions: []
  },
  getters: {
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setCompanyList(state, companyList) {
      state.companyList = companyList
    },
    setStaffInfo(state, staffInfo) {
      state.staffInfo = staffInfo
    },
    setPermissions(state, permissions) {
      state.permissions = permissions
    },
  },
  actions: {
    async getAppInfoByCode(ctx, data) {
      return await getAppInfoByCode(data)
    },
    async getCompanyInfo(ctx, data) {
      const res = await getCompanyInfo(data)
      ctx.commit('setUserInfo', res)
      try {
        const res = await Promise.all([
          ctx.dispatch('getUserStaffInfo'),
          ctx.dispatch('getUserPermissions')
        ])
        ctx.commit('setStaffInfo', res[0] || {})
        ctx.commit('setPermissions', res[1] || [])
      } catch (error) {
        ctx.commit('setStaffInfo', {})
        ctx.commit('setPermissions', [])
      }
      return res
    },
    // 获取当前账号员工信息
    async getUserStaffInfo() {
      const res = await getUserStaffInfo()
      return res
    },
    // 获取当前账号权限
    async getUserPermissions() {
      const res = await getUserPermissions
      return res
    },
    async getCompanyList(ctx, data) {
      const res = await getCompanyList(data)
      ctx.commit('setCompanyList', res)
      return res
    },
    async selectCompany(ctx, data) {
      return await selectCompany(data)
    },
    async checkEntAuth(ctx, data) {
      return await checkEntAuth(data)
    },
    async getAuthLink(ctx, data) {
      return await getAuthLink(data)
    },
    async logOut(ctx, data) {
      return await logOut(data)
    },
  }
}
